// extracted by mini-css-extract-plugin
module.exports = {"container":"TrendingGenreSelectionPage_container__1NzOr","pageBackground":"TrendingGenreSelectionPage_pageBackground__32sp3"};